import { render, staticRenderFns } from "./pageBanner.vue?vue&type=template&id=4deb14fb&scoped=true"
import script from "./pageBanner.vue?vue&type=script&lang=js"
export * from "./pageBanner.vue?vue&type=script&lang=js"
import style0 from "./pageBanner.vue?vue&type=style&index=0&id=4deb14fb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deb14fb",
  null
  
)

export default component.exports